import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import ActiveCatalogue from "../ActiveCatalogue/ActiveCatalogue";
import BrandLogoSlider from "../BrandLogoSlider";
import Footer from "../Footer";
import Header from "../Header";
import ShoppingCart from "../ShoppingCart";
import ShoppingCartInfo from "../ShoppingCart/ShoppingCartInfo";
import ShoppingCartShipping from "../ShoppingCart/ShoppingCartShipping";

const ShoppingCartTabs = () => {
  const [activeTab, setActiveTab] = useState("shipping");

  // const usePathname = () => {
  //     const location = useLocation();
  //     return location.pathname;
  // }
  const path = useLocation().pathname;
  const handleTab1 = () => {
    // update the state to tab1
    setActiveTab("/shopping-cart");
  };
  // const handleTab2 = () => {
  //   // update the state to tab2
  //   setActiveTab("/shopping-cart-shipping");
  // };
  const handleTab3 = () => {
    // update the state to tab2
    setActiveTab("/shopping-cart-info");
  };

  return (
    <>
      <Header />
      <ActiveCatalogue />
      <section className="main-container col1-layout">
        <Container className="main">
          <div className="col-main">
            <div className="shopping-cart-inner">
              <div className="page-title">
                <h2>My Cart</h2>
              </div>
              <div className="page-content">
                {/* {path + activeTab} */}
                <ul className="step">
                  <Link to="/shopping-cart" onClick={handleTab1}>
                    <li className={path === "/shopping-cart" && "current-step"}>
                      <i className="fa fa-shopping-basket"></i>
                      <span> Cart</span>
                    </li>
                  </Link>
                  {/* <Link to="/shopping-cart-shipping">
                    <li
                      onClick={handleTab2}
                      className={
                        path === "/shopping-cart-shipping" && "current-step"
                      }
                    >
                      <i className="fa fa-map-marker"></i>
                      <span> Shipping</span>
                    </li>
                  </Link> */}
                  <Link to="/shopping-cart-info">
                    <li
                      onClick={handleTab3}
                      className={
                        (path === "/shopping-cart-info" && "current-step") ||
                        (path === "/shopping-cart-approval-info" &&
                          "current-step")
                      }
                    >
                      <i className="fa fa-clipboard"></i>
                      <span> Shipping Address Info</span>
                    </li>
                  </Link>
                </ul>
              </div>
            </div>
            {path === "/shopping-cart" && <ShoppingCart />}
            {path === "/shopping-cart-shipping" && <ShoppingCartShipping />}
            {path === "/shopping-cart-info" && <ShoppingCartInfo />}
            {path === "/shopping-cart-approval-info" && <ShoppingCartInfo />}
          </div>
        </Container>
      </section>
      <BrandLogoSlider />
      <Footer displayFooterTop={false} />
    </>
  );
};

export default ShoppingCartTabs;
